import { Box, Skeleton, Theme, useMediaQuery } from '@mui/material'
import React from 'react'

const BUTTON_SKELETON_HEIGHT = 32
const BUTTON_SKELETON_WIDTH = 150
const VEHICLE_SKELETON_HEIGHT = 400

/**
 * Vehicles loading component with two buttons and
 */
const VehiclesLoading: React.VFC = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pb: 2 }}>
        {isMobile && <Skeleton variant="rounded" sx={{ width: '50%', height: BUTTON_SKELETON_HEIGHT }} />}
        <Skeleton variant="rounded" sx={{ width: isMobile ? '50%' : BUTTON_SKELETON_WIDTH, height: BUTTON_SKELETON_HEIGHT }} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 2 }}>
        <Skeleton variant="rectangular" sx={{ width: isMobile ? '100%' : '50%', height: VEHICLE_SKELETON_HEIGHT }} />
        <Skeleton variant="rectangular" sx={{ width: isMobile ? '100%' : '50%', height: VEHICLE_SKELETON_HEIGHT }} />
      </Box>
    </Box>
  )
}

export default VehiclesLoading
